'use client'
import {observer} from 'mobx-react'
import {usePathname, useSearchParams} from 'next/navigation'

import {useEffect} from 'react'
import {createGlobalStyle, css} from 'styled-components'

import theme from '@/src/config/theme'

import * as UI from './mobile-sidebar.styled'
import {useLayoutStore} from './provider'
import {DeepMenuMobile} from '@/src/features/catalog/deep-menu-mobile'
import {Routes} from '@/src/config/routes'

const GlobalStyle = createGlobalStyle<{$opened: boolean}>`
  ${({$opened}) =>
    $opened &&
    css`
      body {
        height: calc(100vh + ${theme.token.layout.headerHeight}px);
        //overflow-y: hidden;
      }
    `}
`

interface IProps {
  links: NavItems
}

export const MobileSidebar = observer(({links}: IProps) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const store = useLayoutStore()

  useEffect(() => {
    store.onPathChanged()
  }, [pathname, searchParams])

  return (
    <>
      <GlobalStyle $opened={store.ui.mobile.menu.opened} />
      <UI.Wrapper $opened={store.ui.mobile.menu.opened}>
        <DeepMenuMobile catalog={store.data.header.catalog ?? []} />
        <UI.NavLinks>
          <ul>
            {links.map(link => (
              <UI.NavListItem key={link.key}>
                <UI.NavLink
                  href={
                    link.href ? Routes.static(link.href, store.data.static_pages ?? []) : link.href
                  }>
                  {link.label}
                </UI.NavLink>
              </UI.NavListItem>
            ))}
          </ul>
        </UI.NavLinks>
      </UI.Wrapper>
    </>
  )
})
